import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { registerEmail } from '@/api/modules/login';
import Captcha from './Captcha';
import LoginService from './LoginService';
export default {
  name: 'login-card',
  components: {
    Captcha,
    LoginService
  },
  data() {
    return {
      form: this.$form.createForm(this, {
        name: 'register'
      }),
      isSend: false,
      secondLeft: 30
    };
  },
  methods: {
    goLogin() {
      this.$emit('toggle-register');
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const params = {
            email: values.email,
            verify_code: values.code,
            company_name: values.company,
            department_name: values.department,
            customer_name: values.name,
            mobile: values.mobile
          };
          registerEmail(params).then(res => {
            if (res.code === 1) {
              _message.success('注册成功');
              this.$router.replace({
                path: '/homepage'
              });
            }
          });
        } else {
          _message.error('请重新正确输入');
          this.form.resetFields();
        }
      });
    },
    handleViewAgreement() {
      const routeUrl = this.$router.resolve({
        path: '/agreement'
      });
      window.open(routeUrl.href, '_blank');
    },
    async handleSendCaptcha() {
      const email = this.form.getFieldValue('email');
      if (email) {
        this.$http.login.sendCaptcha({
          email,
          is_login: false
        }).then(res => {
          if (res.code === 1) {
            this.$message.success('验证码已发送至您的邮箱');
            this.$refs.captcha.countDown();
          }
        });
      } else {
        this.form.validateFields(['email'], err => {
          console.log(err);
        });
      }
    }
  }
};